module.exports = __webpack_public_path__ + "img/nf.92d1cd81.png";